export const resolveAuthToken = (sessionOrTokens) => {
  const tokens = sessionOrTokens?.tokens ?? sessionOrTokens;
  if (!tokens) return "";

  const normalise = (token) => {
    if (!token) return "";
    if (typeof token === "string") return token;
    if (typeof token === "object" && typeof token.toString === "function") {
      try {
        return token.toString();
      } catch {
        return "";
      }
    }
    return "";
  };

  // ✅ Always use only the ID token
  return normalise(tokens.idToken);
};

export const resolveRefreshToken = (sessionOrTokens) => {
  const tokens = sessionOrTokens?.tokens ?? sessionOrTokens;
  const token = tokens?.refreshToken;
  if (!token) return "";
  return typeof token === "string"
    ? token
    : typeof token?.toString === "function"
    ? token.toString()
    : "";
};